export const fantomPools = [
  {
    id: 'fantom-bifi-maxi',
    logo: 'single-assets/BIFI.png',
    name: 'BIFI Maxi',
    token: 'BIFI',
    tokenDescription: 'Beefy.Finance',
    tokenAddress: '0xd6070ae98b8069de6B494332d1A1a81B6179D960',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooFantomBIFI',
    earnedTokenAddress: '0xbF07093ccd6adFC3dEB259C557b61E94c1F66945',
    earnContractAddress: '0xbF07093ccd6adFC3dEB259C557b61E94c1F66945',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'BIFI',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Beefy.Finance',
    assets: ['BIFI'],
    callFee: 0.05,
    withdrawalFee: '0.05%',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-mim-ftm',
    name: 'MIM-FTM LP',
    token: 'MIM-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x6f86e65b255c9111109d2D2325ca2dFc82456efc',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooMIM-FTM',
    earnedTokenAddress: '0x6676C93eb0F2daEfD3b9d03De2E3b18F888cF942',
    earnContractAddress: '0x6676C93eb0F2daEfD3b9d03De2E3b18F888cF942',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-mim-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'MIM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-boo-ftm',
    name: 'BOO-FTM LP',
    token: 'BOO-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xEc7178F4C41f346b2721907F5cF7628E388A7a58',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooBoo-FTM',
    earnedTokenAddress: '0xEe3a7c885Fd3cc5358FF583F2DAB3b8bC473316f',
    earnContractAddress: '0xEe3a7c885Fd3cc5358FF583F2DAB3b8bC473316f',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-boo-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'BOO'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'tomb-tshare-ftm',
    logo: 'fantom/TSHARE-FTM.png',
    name: 'TSHARE-FTM LP',
    token: 'TSHARE-FTM LP',
    tokenDescription: 'SpookySwap (Tomb)',
    tokenAddress: '0x4733bc45eF91cF7CcEcaeeDb794727075fB209F2',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTombTSHARE-FTM',
    earnedTokenAddress: '0xae94e96bF81b3a43027918b138B71a771D381150',
    earnContractAddress: '0xae94e96bF81b3a43027918b138B71a771D381150',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tomb-tshare-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'TombFinance',
    assets: ['TSHARE', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl:
      'https://spookyswap.finance/add/FTM/0x4cdF39285D7Ca8eB3f090fDA0C069ba5F4145B37',
    buyTokenUrl:
      'https://spookyswap.finance/swap?outputCurrency=0x4cdF39285D7Ca8eB3f090fDA0C069ba5F4145B37',
  },
  {
    id: 'tomb-tomb-ftm',
    logo: 'fantom/TOMB-FTM.png',
    name: 'TOMB-FTM LP',
    token: 'TOMB-FTM LP',
    tokenDescription: 'SpookySwap (Tomb)',
    tokenAddress: '0x2A651563C9d3Af67aE0388a5c8F89b867038089e',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTombTOMB-FTM',
    earnedTokenAddress: '0x27c77411074ba90cA35e6f92A79dAd577c05A746',
    earnContractAddress: '0x27c77411074ba90cA35e6f92A79dAd577c05A746',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tomb-tomb-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'TombFinance',
    assets: ['TOMB', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl:
      'https://spookyswap.finance/add/FTM/0x6c021Ae822BEa943b2E66552bDe1D2696a53fbB7',
    buyTokenUrl:
      'https://spookyswap.finance/swap?outputCurrency=0x6c021Ae822BEa943b2E66552bDe1D2696a53fbB7',
  },
  {
    id: 'boo-bifi-ftm',
    logo: 'fantom/BIFI-FTM.png',
    name: 'BIFI-FTM LP',
    token: 'BIFI-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x1656728af3a14e1319F030Dc147fAbf6f627059e',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooBIFI-FTM',
    earnedTokenAddress: '0xe8188B9701E6DB1Fe24c75783474D22e5957BBEF',
    earnContractAddress: '0xe8188B9701E6DB1Fe24c75783474D22e5957BBEF',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-bifi-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['BIFI', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-ftm-ice',
    logo: 'fantom/ICE-FTM.png',
    name: 'ICE-FTM LP',
    token: 'ICE-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x623EE4a7F290d11C11315994dB70FB148b13021d',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooFTM-ICE',
    earnedTokenAddress: '0x33E0Feb374C9B7fC3Ac392140BdE3036263D8e5e',
    earnContractAddress: '0x33E0Feb374C9B7fC3Ac392140BdE3036263D8e5e',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-ftm-ice',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'ICE'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-ftm-badger',
    logo: 'fantom/BADGER-FTM.png',
    name: 'BADGER-FTM LP',
    token: 'BADGER-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x1c94665FD3ecFa969Feda7Ed01e35522e6982022',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooFTM-BADGER',
    earnedTokenAddress: '0x9344e006518af9739F4077014F8B7794777Ae96F',
    earnContractAddress: '0x9344e006518af9739F4077014F8B7794777Ae96F',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-ftm-badger',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'BADGER'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-ftm-band',
    logo: 'fantom/BAND-FTM.png',
    name: 'BAND-FTM LP',
    token: 'BAND-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x91b39D5584e2A7DC829f696235742cc293F2e8cf',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooFTM-BAND',
    earnedTokenAddress: '0xf2e4C5b0Ed40716cB23cCE7eBd15ECDCDa934EDf',
    earnContractAddress: '0xf2e4C5b0Ed40716cB23cCE7eBd15ECDCDa934EDf',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-ftm-band',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'BAND'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-ftm-sushi',
    logo: 'fantom/SUSHI-FTM.png',
    name: 'SUSHI-FTM LP',
    token: 'SUSHI-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xf84E313B36E86315af7a06ff26C8b20e9EB443C3',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooFTM-SUSHI',
    earnedTokenAddress: '0xb8c90D7C60Cf88915BCc4F388F207D5F7fDaA9b4',
    earnContractAddress: '0xb8c90D7C60Cf88915BCc4F388F207D5F7fDaA9b4',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-ftm-sushi',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'SUSHI'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-ftm-usdc',
    logo: 'fantom/USDC-FTM.png',
    name: 'FTM-USDC LP',
    token: 'FTM-USDC LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x2b4C76d0dc16BE1C31D4C1DC53bF9B45987Fc75c',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooFTM-USDC',
    earnedTokenAddress: '0x41D44B276904561Ac51855159516FD4cB2c90968',
    earnContractAddress: '0x41D44B276904561Ac51855159516FD4cB2c90968',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-ftm-usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['FTM', 'USDC'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-any-ftm',
    logo: 'fantom/ANY-FTM.png',
    name: 'ANY-FTM LP',
    token: 'ANY-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x5c021D9cfaD40aaFC57786b409A9ce571de375b4',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooANY-FTM',
    earnedTokenAddress: '0xEE40C6Decc15dCeCE7a836e5CD5Ff94523D32265',
    earnContractAddress: '0xEE40C6Decc15dCeCE7a836e5CD5Ff94523D32265',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-any-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['ANY', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-dai-ftm',
    logo: 'fantom/DAI-FTM.png',
    name: 'DAI-FTM LP',
    token: 'DAI-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xe120ffBDA0d14f3Bb6d6053E90E63c572A66a428',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooDAI-FTM',
    earnedTokenAddress: '0x8316b990De26eB530B7B1bb0d87f5b0a304637cd',
    earnContractAddress: '0x8316b990De26eB530B7B1bb0d87f5b0a304637cd',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-dai-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['DAI', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'ester-est-ftm',
    logo: 'fantom/EST-FTM.png',
    name: 'EST-FTM LP',
    token: 'EST-FTM LP',
    tokenDescription: 'SpiritSwap',
    tokenAddress: '0x0c9043cb1B994C8e4a8024e2F037Ea50b7025a82',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooEsterEST-FTM',
    earnedTokenAddress: '0x59247cfe6FC768A8C3F95601008B75A94F4939Bd',
    earnContractAddress: '0x59247cfe6FC768A8C3F95601008B75A94F4939Bd',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'ester-est-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Ester',
    assets: ['EST', 'FTM'],
    callFee: 0.05,
    addLiquidityUrl:
      'https://swap.spiritswap.finance/#/add/FTM/0x181F3F22C9a751E2ce673498A03E1FDFC0ebBFB6',
    buyTokenUrl:
      'https://swap.spiritswap.finance/#/swap?outputCurrency=0x181f3f22c9a751e2ce673498a03e1fdfc0ebbfb6',
  },
  {
    id: 'ester-est',
    logo: 'fantom/EST.png',
    name: 'EST',
    token: 'EST',
    tokenDescription: 'Ester',
    tokenAddress: '0x181F3F22C9a751E2ce673498A03E1FDFC0ebBFB6',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooEsterEST',
    earnedTokenAddress: '0x7076a33b6525132fF77F0FeE2daB2a1e79688DA0',
    earnContractAddress: '0x7076a33b6525132fF77F0FeE2daB2a1e79688DA0',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'EST',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Ester',
    assets: ['EST'],
    callFee: 0.05,
    buyTokenUrl:
      'https://swap.spiritswap.finance/#/swap?outputCurrency=0x181f3f22c9a751e2ce673498a03e1fdfc0ebbfb6',
  },
  {
    id: 'boo-woofy-ftm',
    logo: 'fantom/WOOFY-FTM.png',
    name: 'WOOFY-FTM LP',
    token: 'WOOFY-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xfD0aB56B83130ce8f2b7A4f4d4532dEe495c0794',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooWOOFY-FTM',
    earnedTokenAddress: '0x7CE2332fAF6328986C75e3A8fCc1CB79621aeB1F',
    earnContractAddress: '0x7CE2332fAF6328986C75e3A8fCc1CB79621aeB1F',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-woofy-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['WOOFY', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-boo',
    logo: 'fantom/BOO.png',
    name: 'BOO',
    token: 'BOO',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooBOO',
    earnedTokenAddress: '0x15DD4398721733D8273FD4Ed9ac5eadC6c018866',
    earnContractAddress: '0x15DD4398721733D8273FD4Ed9ac5eadC6c018866',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'BOO',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['BOO'],
    callFee: 0.5,
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-bnb-ftm',
    logo: 'fantom/BNB-FTM.png',
    name: 'BNB-FTM LP',
    token: 'BNB-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x956DE13EA0FA5b577E4097Be837BF4aC80005820',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooBNB-FTM',
    earnedTokenAddress: '0xC5b2a6aB801E74F098aCC8Bb62B786b47319c4D9',
    earnContractAddress: '0xC5b2a6aB801E74F098aCC8Bb62B786b47319c4D9',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-bnb-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['BNB', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'froyo-3pool',
    logo: 'fantom/FROYO-3Pool.png',
    name: 'USDT/DAI/USDC',
    token: 'FROYO 3Pool',
    tokenDescription: 'Froyo',
    tokenAddress: '0x4f85Bbf3B0265DCEd4Ec72ebD0358ccCf190F1B3',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooFroyo3Pool',
    earnedTokenAddress: '0xb18398ad9735fea37C97dcba50C0Bb947Dc0eeBD',
    earnContractAddress: '0xb18398ad9735fea37C97dcba50C0Bb947Dc0eeBD',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'froyo-3pool',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Froyo',
    assets: ['USDT', 'DAI', 'USDC'],
    callFee: 0.5,
    addLiquidityUrl: 'https://frozenyogurt.finance/pool',
  },
  {
    id: 'froyo-froyo-ftm',
    logo: 'fantom/FROYO.png',
    name: 'FROYO-FTM LP',
    token: 'FROYO-FTM LP',
    tokenDescription: 'SushiSwap',
    tokenAddress: '0xBE0AF661BC9794E05fAb18C08C2C99811A0F45D2',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooFroyoFROYO-FTM',
    earnedTokenAddress: '0xeD4ea30c755676C07d3e0e0f74Ff84C0193B4551',
    earnContractAddress: '0xeD4ea30c755676C07d3e0e0f74Ff84C0193B4551',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'froyo-froyo-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Froyo',
    assets: ['FROYO', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://app.sushi.com/add/ETH/0xA92d41Ab8eFeE617d80a829CD9F5683c5F793ADA',
    buyTokenUrl:
      'https://app.sushi.com/swap?outputCurrency=0xA92d41Ab8eFeE617d80a829CD9F5683c5F793ADA',
  },
  {
    id: 'boo-link-ftm',
    logo: 'fantom/LINK-FTM.png',
    name: 'LINK-FTM LP',
    token: 'LINK-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x89d9bC2F2d091CfBFc31e333D6Dc555dDBc2fd29',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooLINK-FTM',
    earnedTokenAddress: '0x711969A90C9EDD815A5C2b441FC80d067EC5E969',
    earnContractAddress: '0x711969A90C9EDD815A5C2b441FC80d067EC5E969',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-link-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['LINK', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-cover-ftm',
    logo: 'fantom/COVER-FTM.png',
    name: 'COVER-FTM LP',
    token: 'COVER-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x5DC7848bF215F1D99F2AF3d2Bf78fcdf238EE34b',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooCOVER-FTM',
    earnedTokenAddress: '0xF5Bf6b3624eb10Ee855FEC1C5a4af81D90996b6c',
    earnContractAddress: '0xF5Bf6b3624eb10Ee855FEC1C5a4af81D90996b6c',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-cover-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['COVER', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-cream-ftm',
    logo: 'fantom/CREAM-FTM.png',
    name: 'CREAM-FTM LP',
    token: 'CREAM-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xb77b223490e1f5951ec79A8d09Db9Eab2ADCB934',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooCREAM-FTM',
    earnedTokenAddress: '0x2BDA70d1DcE6b0855e812daaBB096F3DaaEBd4Bc',
    earnContractAddress: '0x2BDA70d1DcE6b0855e812daaBB096F3DaaEBd4Bc',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-cream-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['CREAM', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-snx-ftm',
    logo: 'fantom/SNX-FTM.png',
    name: 'SNX-FTM LP',
    token: 'SNX-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x06d173628bE105fE81F1C82c9979bA79eBCAfCB7',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooSNX-FTM',
    earnedTokenAddress: '0x74907ad4E79b1Ce415caB26FEf526ae017598cEe',
    earnContractAddress: '0x74907ad4E79b1Ce415caB26FEf526ae017598cEe',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-snx-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['SNX', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-usdt-ftm',
    logo: 'fantom/USDT-FTM.png',
    name: 'fUSDT-FTM LP',
    token: 'fUSDT-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0x5965E53aa80a0bcF1CD6dbDd72e6A9b2AA047410',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooUSDT-FTM',
    earnedTokenAddress: '0x5d89017d2465115007AbA00da1E6446dF2C19f34',
    earnContractAddress: '0x5d89017d2465115007AbA00da1E6446dF2C19f34',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-usdt-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['fUSDT', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-btc-ftm',
    logo: 'fantom/BTC-FTM.png',
    name: 'BTC-FTM LP',
    token: 'BTC-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xFdb9Ab8B9513Ad9E419Cf19530feE49d412C3Ee3',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooBTC-FTM',
    earnedTokenAddress: '0xA3e3Af161943CfB3941B631676134bb048739727',
    earnContractAddress: '0xA3e3Af161943CfB3941B631676134bb048739727',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-btc-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['BTC', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-eth-ftm',
    logo: 'fantom/ETH-FTM.png',
    name: 'ETH-FTM LP',
    token: 'ETH-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xf0702249F4D3A25cD3DED7859a165693685Ab577',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooETH-FTM',
    earnedTokenAddress: '0x2a30C5e0d577108F694d2A96179cd73611Ee069b',
    earnContractAddress: '0x2a30C5e0d577108F694d2A96179cd73611Ee069b',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-eth-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['ETH', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-aave-ftm',
    logo: 'fantom/AAVE-FTM.png',
    name: 'AAVE-FTM LP',
    token: 'AAVE-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xeBF374bB21D83Cf010cC7363918776aDF6FF2BF6',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooAAVE-FTM',
    earnedTokenAddress: '0xDa4bb93Bac7CC00F6c6e2193d115Cf45099b31a0',
    earnContractAddress: '0xDa4bb93Bac7CC00F6c6e2193d115Cf45099b31a0',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-aave-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['AAVE', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
  {
    id: 'boo-crv-ftm',
    logo: 'fantom/CRV-FTM.png',
    name: 'CRV-FTM LP',
    token: 'CRV-FTM LP',
    tokenDescription: 'SpookySwap',
    tokenAddress: '0xB471Ac6eF617e952b84C6a9fF5de65A9da96C93B',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooBooCRV-FTM',
    earnedTokenAddress: '0xdf68Bf80D427A5827Ff2c06A9c70D407e17DC041',
    earnContractAddress: '0xdf68Bf80D427A5827Ff2c06A9c70D407e17DC041',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'boo-crv-ftm',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'SpookySwap',
    assets: ['CRV', 'FTM'],
    callFee: 0.5,
    addLiquidityUrl: 'https://spookyswap.finance/add',
    buyTokenUrl: 'https://spookyswap.finance/swap',
  },
];
